// extracted by mini-css-extract-plugin
export var required = "_qp-0";